<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<app-cigent-header
        smallTitle=""
        largeTitle="{{'maintenance.title' | translate}}"
        description="{{'maintenance.text' | translate}}">
</app-cigent-header>
